import { createReducer } from "@reduxjs/toolkit";
import { TYPES } from "../../common/constants";

const initialState = {
  serviceRequests: [],
  summary: {
    total: 0,
    active: 0,
    closed: 0,
    closedPercentage: 0,
    averageDaysToResolution: 0,
  },
}

export default createReducer(initialState, {
  [TYPES.FETCH_SERVICE_REQUEST_STATS_DONE]: (_, { payload }) => ({serviceRequests: payload.serviceRequests, summary: payload.summary}),
  [TYPES.CLEAR_SERVICE_REQUEST_STATS_DONE]: () => ({...initialState}),
});
